export default __webpack_public_path__ + "static/media/pesquisadores-inicio.faff6586.png";